import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  input: {
    base: {
      borderRadius: theme.settings.borderRadiuses.regular,
      outline: 'none',
      paddingTop: theme.settings.spacing.small,
      paddingRight: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.small,
      paddingLeft: theme.settings.spacing.medium,
      marginBottom: 0,
      width: '100%',
      height: '40px',
      justifyContent: 'flex-start',
      display: 'flex',
      appearance: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      transition: `border ${theme.settings.transitions.regularFast}`,
      boxSizing: 'border-box',
      boxShadow: theme.settings.shadows.depression[0],
    },
    normal: {
      backgroundColor: 'white',
      border: theme.settings.borders.regular,
      color: theme.colors.text.normal,
      ':focus': {
        backgroundColor: 'white',
        border: `1px solid ${theme.colors.accents.primaryFocus}`,
      },
    },
    readOnly: {
      backgroundColor: 'rgba(204, 204, 204, 0.1)',
      border: theme.settings.borders.regular,
      color: '#404e59',
      opacity: 0.75,
      ':hover': {
        backgroundColor: 'rgba(204, 204, 204, 0.1)',
      },
    },
    disabled: {
      backgroundColor: 'rgba(204, 204, 204, 0.1)',
      border: theme.settings.borders.regular,
      color: '#404e59',
      opacity: 0.5,
      ':hover': {
        backgroundColor: 'rgba(204, 204, 204, 0.1)',
      },
    },
    password: {},
    success: {
      backgroundColor: 'rgba(18, 206, 102, 0.05)',
      border: '1px solid rgba(18, 206, 102, 0.50)',
    },
    error: {
      backgroundColor: 'rgba(255, 102, 102, 0.05)',
      border: '1px solid rgba(255, 102, 102, 0.5)',
    },
    withIcon: {
      // Assuming the icon is 20px wide
      paddingRight: `${parseInt(theme.settings.spacing.medium, 10) * 2 + 20}px`,
    },
    multiline: {
      ...theme.typography.body,
      paddingTop: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.medium,
      height: '120px',
    },
  },

  icon: {
    base: {
      position: 'absolute',
      top: '50%',
      right: theme.settings.spacing.medium,
      transform: 'translateY(-50%)',
      cursor: 'pointer',
    },
    multiline: {
      top: theme.settings.spacing.small,
      transform: 'none',
    },
    alignRight: {
      right: 0,
    },
  },

  completionList: {
    base: {
      position: 'absolute',
      width: '100%',
      maxHeight: '320px',
      backgroundColor: 'white',
      border: theme.settings.borders.regular,
      borderRadius: theme.settings.borderRadiuses.regular,
      boxShadow: theme.settings.shadows.elevation[0],
      padding: 0,
      margin: 0,
      top: '45px',
      listStyle: 'none',
      overflowY: 'auto',
      zIndex: 100,
    },
  },

  completionItem: {
    base: {
      ...theme.typography.body,
      paddingTop: theme.settings.spacing.small,
      paddingRight: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.small,
      paddingLeft: theme.settings.spacing.medium,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: 'white',
      cursor: 'pointer',
      height: '40px',
      boxSizing: 'border-box',
      fontWeight: theme.settings.typography.weights.semibold,
      ':hover': {
        backgroundColor: '#f7f9fb',
      },
    },
    createable: {
      color: theme.colors.accents.primary,
    },
    selected: {
      backgroundColor: '#f7f9fb',
    },
    isLabel: {
      color: theme.colors.text.normal,
      opacity: 0.5,
      cursor: 'default',
      ':hover': {
        backgroundColor: 'white',
      },
    },
  },

  completionItemHighlight: {
    base: {
      textDecoration: 'underline',
    },
  },

  wrapper: {
    base: {
      position: 'relative',
      width: '100%',
      height: '40px',
      display: 'block',
      flex: 1,
      marginBottom: theme.settings.spacing.small,
      textAlign: 'left',
    },

    multiline: {
      height: '120px',
    },

    flush: {
      marginBottom: 0,
    },
  },

  richtext: {
    base: {
      height: 'auto',
    },
  },
})
